import { render, staticRenderFns } from "./redHeadedFileModal.vue?vue&type=template&id=3568b063"
import script from "./redHeadedFileModal.vue?vue&type=script&lang=js"
export * from "./redHeadedFileModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports